/**
 * Footer
 */

// Vendors
import $ from 'jquery';

$(() => setFooterHeight());
$(window).on('load resize', () => setFooterHeight());

function setFooterHeight() {
  $('.site-footer-spacer').height($('.site-footer').outerHeight());
}
